<template>
  <div class="mapDetail">
    <!-- map -->
    <div class="baidumap" id="allmap"></div>
    <br>
    <br>
  </div>
</template>

<script>
export default {
  name: "mapDetail",
  data() {
    return {};
  },
  mounted() {
    this.baiduMap();
  },
  methods: {
    baiduMap() {
      var map = new window.BMap.Map("allmap"); //创建地图
      map.enableScrollWheelZoom(); //启用滚轮放大缩小
      var point = new window.BMap.Point(114.132648, 22.688133); //设置地图位置
      map.centerAndZoom(point, 12);
      var marker = new window.BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.baidumap {
  width: 100%;
  height: 420px;
  margin: 40px auto;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/contact/mapDetail.vue